import React from "react";
import { PROFILE } from "@/data/portfolio";

const LINKS = [
  { key: "email", label: "Email", value: PROFILE.email, href: PROFILE.socials.email, testid: "email-link" },
  { key: "phone", label: "Phone", value: PROFILE.phone, href: `tel:${PROFILE.phone.replace(/\s+/g, "")}`, testid: "phone-link" },
  { key: "github", label: "GitHub", value: "ashraf-0907", href: PROFILE.socials.github, testid: "github-profile-link" },
  { key: "leetcode", label: "LeetCode", value: "ashraf_0907", href: PROFILE.socials.leetcode, testid: "leetcode-profile-link" },
  { key: "linkedin", label: "LinkedIn", value: "mdashrafk", href: PROFILE.socials.linkedin, testid: "linkedin-profile-link" },
];

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-background"
    >
      <div className="max-w-3xl mx-auto px-6 py-10">
        <hr className="rule" />
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-4">
          Get in touch
        </h2>

        <p className="text-base text-foreground/85 leading-relaxed">
          I'm open to backend engineering roles, contract work, or a quiet
          conversation about distributed systems, MongoDB tuning, or
          TypeScript. The easiest way to reach me is{" "}
          <a
            href={PROFILE.socials.email}
            data-testid="contact-email-cta"
            className="link"
          >
            email
          </a>
          .
        </p>

        <dl className="mt-8 space-y-1.5">
          {LINKS.map((l) => (
            <div key={l.key} className="flex flex-wrap gap-x-3 text-base">
              <dt className="text-quiet small-caps min-w-[6rem]">
                {l.label}
              </dt>
              <dd>
                <a
                  href={l.href}
                  target={l.href.startsWith("http") ? "_blank" : undefined}
                  rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                  data-testid={l.testid}
                  className="link"
                >
                  {l.value}
                </a>
              </dd>
            </div>
          ))}
        </dl>

        <p className="mt-8 text-base text-foreground/85">
          Or just{" "}
          <a
            href={PROFILE.resume}
            download
            data-testid="contact-resume-download"
            className="link"
          >
            grab my résumé (PDF)
          </a>
          .
        </p>
      </div>
    </section>
  );
};
